const Colors = {
  primary: '#323232',
  white: '#FFFFFF',
  black: '#000000',
  gray: '#F5F5F5',
};

export {Colors};
